
import api, { apiInternal } from '../api';


export async function changePassword( params) {
  const result = await api.post(`${apiInternal}/account/changePassword`, params);
  return result;
}

export async function resetPassword( params) {

  const result = await api.post(`${apiInternal}/account/resetPassword`, params);
  return result;
}

export async function validateResetPassword( params) {
  const result = await api.post(`${apiInternal}/account/validateresetpassword`, params);
  return result;
}

export async function login(params) {
  const result = await api.post(`${apiInternal}/login`, params);
  return result;
}

export async function passwordPolicy() {
  const { data } = await api.post(`${apiInternal}/account/getPasswordPolicy`, {});
  return data;
}


export async function logout() {
  const result = await api.post(`${apiInternal}/logout`, {});
  return result;
}